module.exports = __webpack_public_path__ + "static/media/DL_Logo.75a7107b.png";